// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3RWp1","content":"GlobalSearch_content__N04xy"};